module.exports = "/assets/data/0b71c5461c650aa17b60bac68b97dd1e-GL17.data.json";